import './IsRequired.css';

function IsRequired() {
    return (
        <span className="is-required">*</span>
    )
}

export default IsRequired;